import { useQueryClient } from '@tanstack/react-query';
import type { HeaderApiResponse } from '../api';

export function useHeaderData() {
  const client = useQueryClient();
  return client.getQueryData<HeaderApiResponse>(['header'])?.data;
}
